import { getFullName } from "shared/utils/get-full-name";
import { getStateLabel } from "utils/stateCodes";
import { CriminalStatewideSearchActivity } from "../types";

export const CriminalStatewideSearch = ({
  activity
}: {
  activity: CriminalStatewideSearchActivity;
}) => {
  const isRequested =
    activity.activity_type === "criminal_statewide_search_requested";
  const author = activity.author?.name ?? activity.author?.email;
  const { contact, state_code } = activity.details;

  return (
    <div>
      <p className="text-base font-bold text-content-1000">
        {isRequested
          ? "Statewide search was requested"
          : "Statewide search results received"}
        {isRequested && author ? (
          <span className="font-normal text-content-400"> by {author}</span>
        ) : null}
      </p>
      <p className="text-sm text-content-400 mt-2">
        {`State: ${getStateLabel(state_code)}, Applicant: ${getFullName({
          firstName: contact.first_name,
          lastName: contact.last_name,
          short: true
        })}`}
      </p>
    </div>
  );
};
